import { typeCreatorV2 } from 'redux/utils/common';

// //  [REDUCER][TYPE]
export const SET_PRODUCT_DETAILS: string = typeCreatorV2(
  'ProductPrintPdfReducer',
  'SetProductDetails'
);
export const RESET_STORE: string = typeCreatorV2(
  'ProductPrintPdfReducer',
  'ResetStore'
);
export const RESET_PRINT: string = typeCreatorV2(
  'ProductPrintPdfReducer',
  'ResetPrint'
);
export const SETUP_PRINT: string = typeCreatorV2(
  'ProductPrintPdfReducer',
  'SetupPrint'
);
export const SET_PRODUCT_DOCUMENT: string = typeCreatorV2(
  'ProductPrintPdfReducer',
  'SetupProductDocument'
);
